// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__30wlZ","header":"Messages_header__JkORr"};